import React from 'react'
import { useParams } from 'react-router-dom'

import { Spinner } from '../../App/Components'

import { ContractForm } from './ContractForm'
import { useGetPersonContractQuery } from './util/usePersonContractQuery'

export const EditContract: React.FC = () => {
  const { personUuid, contractUuid } = useParams<{ [key: string]: string }>()
  const { data, status } = useGetPersonContractQuery(contractUuid)

  if (status === 'pending') {
    return <Spinner />
  }

  if (!data) {
    return <div>Contract not found</div>
  }

  return <ContractForm type={'edit'} personUuid={personUuid} contract={data} />
}
